export enum EventActions {
  button = 'button',
  backToCar = 'back-to-car',
  click = 'click',
  start = 'start',
  cinchcareAddedToOrder = 'cinchCare added to order',
  modalOpened = 'modal-opened',
  modalClosed = 'modal-closed',
  returnToCheckout = 'return-to-checkout',
  orderCompleteClick = 'order complete click',
  orderDeclinedClick = 'order declined click',
  orderTrackingViewed = 'order tracking viewed',
  filter = 'filter',
  navigate = 'navigate',
  noReviewsFound = 'no reviews found',
  saveQuote = 'save-quote',
  personalDetails = 'personal details',
  savePersonalDetails = 'save personal details',
  cancelPersonalDetails = 'cancel personal details',
  firstNameDetails = 'first name details',
  lastNameDetails = 'last name details',
  mobileNumberDetails = 'mobile number details',
  changePassword = 'change password',
  marketingPreferences = 'marketing preferences',
  logOut = 'log out',
  view = 'view',
  deadLink = 'dead click',
  pdpClick = 'pdp click',
  load = 'load',
  search = 'search',
  payInFull = 'pay_full',
  payWithFinance = 'pay_monthly',
  searchAllCars = 'search all cars',
  storeSelected = 'store_selected',
  sellMyCarCTA = 'sell_my_car_cta',
  partExCalculatorSubmit = 'partExCalculatorSubmit',
  backToGuideWithValuation = 'backToGuideWithValuation',
  backToGuideWithNoValuation = 'back-to-guide',
  backToBasketWithValuation = 'back-to-basket-with-valuation',
  backToBasketWithNoValuation = 'backToBasketWithNoValuation',
  partExLandingLoadEvent = 'partExLandingLoadEvent',
  partExLandingClickEvent = 'partExLandingClickEvent',
  back = 'back',
  backToYourCars = 'back-to-your-cars',
  select = 'select',
  focus = 'Focus',
  submit = 'submit',
  accordionOpen = 'accordion_open',
  accordionClose = 'accordion_close',
  continueToCheckout = 'continueToCheckout',
  continue = 'continue',
  financeSettlement = 'finance-settlement',
  editPartEx = 'edit-partex',
  addPartEx = 'add-partex',
  unticked = 'unticked',
  removeFinance = 'remove-finance',
  highValuation = 'high-valuation',
  removePartex = 'remove-partex',
  noPartExNoFinanceQuote = 'no_partex-no_finance-available',
  financeQuote = 'finance-available',
  partexAvailable = 'partex-available',
  editDetailsContinue = 'continue_to_next_step',
  editMyDetails = 'edit_my_details',
  updateMyDetails = 'update_my_details',
  backToOffer = 'back_to_offer',
  editDetailsSubmit = 'submit_and_update',
  backToEditDetails = 'back_to_edit_details',
  ctaClick = 'cta_click',
}

export enum EventCategories {
  button = 'button',
  deliveryOptions = 'delivery options',
  cinchcare = 'cinchcare',
  favourites = 'Favourites',
  orders = 'Orders',
  orderTracking = 'Order Tracking',
  profileDetails = 'Profile Details',
  myProfile = 'My profile',
  reviews = 'reviews',
  personalDetails = 'personal details',
  adminFee = 'admin fees',
  financeChangeCar = 'finance change car',
  image = 'image',
  hyperlinkedTitle = 'hyperlinked title',
  sellMyCar = 'Sell_my_car',
  partExCalculator = 'partExCalculator',
  view = 'view',
  pdpPartEx = 'pdpPartEx',
  field = 'field',
  form = 'form',
  retailExclude = 'retail-exclude',
  wholesaleExclude = 'wholesale-exclude',
  carCarousel = 'CarCarousel',
  financeReviewPage = 'finance_review_page',
  financeEquityRelease = 'finance_equity_release',
  financeQuoteUpdated = 'finance_quote_updated',
  zendeskChatbot = 'zendeskChatbot',
  financeOfferPage = 'finance offer page',
  basket = 'basket',
  text = 'text',
  partexCheckbox = 'partex-checkbox',
  panel = 'panel',
  partExResult = 'partExResult',
}

export enum EventNames {
  click = 'click',
  error = 'error',
  identify = 'identify',
  load = 'load',
  impression = 'impression',
  scAdd = 'scAdd',
}

export enum TrackingEventTypes {
  TRACK = 'trackQueue',
  IDENTIFY = 'identifyQueue',
  PAGE = 'pageQueue',
  ADOBE = 'adobeQueue',
  HOTJAR_EVENT = 'hotJarEventQueue',
  HOTJAR_TAG = 'hotJarTagQueue',
  HOTJAR_TRIGGER = 'hotJarTriggerQueue',
  PAGE_NO_ADOBE = 'pageQueueNoAdobe',
}

export enum SegmentEventsTypes {
  SEARCH_FILTERS_APPLIED = 'SearchFiltersApplied',
}

export enum HotJarTriggers {
  MYPROFILE_WITH_ORDERS = 'myprofile_with_orders',
}

interface AnalyticsEvent {
  eventName: string
  type: Exclude<TrackingEventTypes, TrackingEventTypes.IDENTIFY>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
}

interface IdentifyEvent {
  type: TrackingEventTypes.IDENTIFY
  userId?: string
  data?: Record<string, unknown>
}

export type TrackingEvent = AnalyticsEvent | IdentifyEvent
